import { HITS_TYPES } from '~/pages/const';

export const getSearchableTypesTranslations = (t) => ({
  [HITS_TYPES.PATHWAY]: t('page.discover.pathways'),
  [HITS_TYPES.VIDEO]: t('page.discover.videoModules'),
  [HITS_TYPES.COURSE]: t('page.discover.certificatePrograms'),
  [HITS_TYPES.GLOSSARY]: t('page.discover.glossary'),
  [HITS_TYPES.NEWS]: t('page.discover.text'),
});

export const getDurationTranslations = (t) => ({
  '100': t('page.discover.di0-15m'),
  '200': t('page.discover.di15-60m'),
  '300': t('page.discover.di1-2h'),
  '400': t('page.discover.di3-4h'),
  '500': t('page.discover.di4h'),
});
